import { useStoreConfig, isOpenNow, fmtTime } from "@/hooks/useStoreConfig";
import { imageUrl } from "@/lib/api";

const DEFAULT_HERO_IMG =
  "https://images.unsplash.com/photo-1556712691-5c39e0e32a8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMGZsb3dlciUyMGJvdXF1ZXQlMjByb3Nlc3xlbnwwfHx8fDE3OTAyNzYxNzJ8MA&ixlib=rb-4.1.0&q=85";

const VALUES = [
  { n: "1", title: "Bunga Pilihan Segar", desc: "Dirangkai dari kuntum mekar kualitas utama oleh florist berpengalaman." },
  { n: "2", title: "Jangkauan Seluruh Nusantara", desc: "Pengiriman aman dengan packing khusus menjaga kesegaran hingga tujuan." },
  { n: "3", title: "Transfer Bank Manual", desc: "Cukup checkout di web, transfer manual, dan konfirmasi bukti bayar." },
  { n: "4", title: "Dipercaya Bertahun-tahun", desc: "Langganan perorangan, korporasi, hingga wedding organizer." },
];

export default function Hero() {
  const config = useStoreConfig();
  const status = config?.hours?.length ? isOpenNow(config.hours) : null;
  return (
    <>
      <section
        id="beranda"
        data-testid="hero-section"
        className="relative min-h-[580px] md:min-h-[640px] flex items-end justify-start overflow-hidden border-b border-[#E8E2D5]"
      >
        <div className="absolute inset-0">
          <img
            src={config?.hero_image_url ? imageUrl(config.hero_image_url) : DEFAULT_HERO_IMG}
            alt="Suasana atelier bunga segar Puspita Florist"
            data-testid="hero-image"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#141F14]/95 via-[#141F14]/60 to-transparent"></div>

        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20 text-[#FBF9F5] w-full puspita-animate">
          <div className="max-w-2xl">
            <h1 className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-normal tracking-tight leading-[1.1] mb-5 text-[#FAF7EE]">
              Rangkaian Segar Sepenuh Hati
            </h1>
            <p className="text-base sm:text-lg text-[#D2DFD0] leading-relaxed mb-8 max-w-xl">
              Pusat florist terpercaya yang telah bertahun-tahun dipercaya pelanggan setia di
              seluruh nusantara untuk merangkai kisah, perayaan, dan ungkapan tulus Anda.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="#katalog"
                data-testid="hero-cta-btn"
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-[#FBF9F5] text-[#1E2B1D] font-semibold text-sm hover:bg-[#E9F0E8] transition-colors shadow-md"
              >
                Jelajahi Katalog Bunga
              </a>
              <div className="text-xs text-[#BDCEBB] flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#8FA88B]"></span>
                Stok bunga segar dipotong tiap pagi
              </div>
              {status?.today && (
                <a
                  href="#lokasi"
                  data-testid="hero-hours-badge"
                  className="text-xs flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#3D5A40]/60 bg-[#1C281C]/60 backdrop-blur text-[#D2DFD0] hover:bg-[#1C281C] transition-colors"
                >
                  <span className={`w-2 h-2 rounded-full ${status.open ? "bg-[#7FD18F]" : "bg-[#E8B4B4]"}`}></span>
                  {status.open ? "Buka sekarang" : "Sedang tutup"}
                  {!status.today.closed && ` · ${fmtTime(status.today.open)}–${fmtTime(status.today.close)}`}
                </a>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 bg-[#F4EFE6] border-b border-[#E8E2D5]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map((v) => (
              <div key={v.n} className="flex items-start gap-3" data-testid={`value-${v.n}`}>
                <div className="w-9 h-9 rounded-full bg-[#E5DEC9] flex items-center justify-center text-[#2D422F] shrink-0 font-serif-display font-bold">
                  {v.n}
                </div>
                <div>
                  <h3 className="text-sm font-bold text-[#1E2B1D]">{v.title}</h3>
                  <p className="text-xs text-[#5E6D5B] mt-0.5">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
